import { useEffect, useState } from 'react';

let gaInitialized = false;
let lastTrackedPath = null;

export default function GoogleAnalytics() {
  const [measurementId, setMeasurementId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function loadConfig() {
      try {
        const res = await fetch('/api/analytics-config');
        const data = await res.json();

        if (!cancelled && data.enabled && data.measurementId) {
          setMeasurementId(data.measurementId);
        }
      } catch (error) {
        console.error('Failed to load analytics config:', error);
      }
    }

    loadConfig();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!measurementId || gaInitialized) return;

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', measurementId, { send_page_view: false });

    gaInitialized = true;

    const initialPath = window.location.pathname + window.location.search;
    gtag('event', 'page_view', {
      page_path: initialPath,
      page_location: window.location.href,
      page_title: document.title
    });
    lastTrackedPath = initialPath;

    console.log('[GA4] Initialized with:', measurementId);
  }, [measurementId]);

  useEffect(() => {
    if (!measurementId) return;

    const trackPageView = () => {
      if (!window.gtag) return;
      const path = window.location.pathname + window.location.search;
      if (path === lastTrackedPath) return;
      lastTrackedPath = path;

      setTimeout(() => {
        window.gtag('event', 'page_view', {
          page_path: path,
          page_location: window.location.href,
          page_title: document.title
        });
      }, 0);
    };

    const originalPushState = history.pushState;
    history.pushState = function (...args) {
      originalPushState.apply(this, args);
      trackPageView();
    };

    window.addEventListener('popstate', trackPageView);

    return () => {
      history.pushState = originalPushState;
      window.removeEventListener('popstate', trackPageView);
    };
  }, [measurementId]);

  return null;
}
